var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPencel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24483 3.01454L3.10352 10.1875L6.76134 12.2993L10.9027 5.12638L7.24483 3.01454Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63867 2.33369C7.95269 1.79025 8.64861 1.60417 9.1927 1.9184L10.8798 2.89226C11.4239 3.20628 11.6104 3.90178 11.2964 4.44544L7.63867 2.33369Z",
    fill: "#CBCBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32179 13.0653L2.97064 14.2991L2.66406 10.9531L6.32179 13.0653Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPencel);
export default __webpack_public_path__ + "static/media/ico-pencel.0c49f63d8a05fad71ffe381c58972324.svg";
export { ForwardRef as ReactComponent };